import { MobileVariant } from "../../types";
import styled from "styled-components";
export const ContentContainer = styled.div `
  ${(props) => props.mobileVariant === MobileVariant.VERTICAL_LINE &&
    `
      display: grid;
      grid-template-columns: 34px auto;
    `};
`;
export const ContentWrapper = styled.div `
  ${(props) => props.mobileVariant === MobileVariant.VERTICAL_LINE &&
    "padding-left: 20px;"};
  ${(props) => (props.mobileVariant === MobileVariant.VERTICAL_LINE_COMPACT ||
    props.mobileVariant === MobileVariant.VERTICAL_LINE) &&
    "margin: 10px 0;"}
`;
//# sourceMappingURL=styled.js.map